import {createSvgIcon} from "@mui/material";

const PlusCircleIcon = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="currentColor"/>
    <path d="M8 16H24" stroke="currentColor"/>
    <path d="M16 8L16 24" stroke="currentColor"/>
  </svg>
, 'PlusCircle')

export default PlusCircleIcon;
